export default "__VITE_ASSET__CvbOjENC__"